import { usePermissions } from "react-admin";
import { ProLogsPermissions } from "./permissions";

export const useActionPermissions = () => {
  const { permissions: permissionsFromState } = usePermissions<
    ProLogsPermissions
  >();
  let permissions: Record<string, boolean> = {};
  if (permissionsFromState) {
    const { actionPermissions } = permissionsFromState;
    if (actionPermissions) {
      permissions = actionPermissions;
    }
  }

  return permissions;
};
